// extracted by mini-css-extract-plugin
export var social = "ie";
export var socialLink = "je";